@if (enableRedesignedBetCard) {
    <ms-my-bets-toolbar-redesign
        [betPlacedDate]="betPlacedDate"
        [betslipId]="betslipId"
        [showShareMyBetButton]="showShareMyBetButton"
        [showEditBetHistoryButton]="showEditBetHistoryButton"
        [placedBetInfo]="placedBetInfo"
        (onBetslipIdClick)="copyToClipboard($event)"
        (onEditBetHistoryClick)="editBetHistory($event)"></ms-my-bets-toolbar-redesign>
} @else {
    <div
        class="my-bets-toolbar"
        [ngClass]="{
            'expanded': isExpanded,
            'toolbar-visible': isToolbarVisible,
            'reward-token-info-included': oddsBoostInfoIncluded || riskFreeInfoIncluded || accaBoostInfoContent,
        }">
        @if (!myBetsListContext.isPrintView) {
            <div class="toolbar-header">
                <div class="toolbar-buttons" msToolbarButtonsHeight [isExpanded]="isExpanded">
                    @if (showPinButton) {
                        <ms-my-bets-pin [betslip]="betslip" [myBetsListContext]="myBetsListContext"></ms-my-bets-pin>
                    }
                    @if (showAlertButton) {
                        <div class="toolbar-button">
                            <ms-alert class="alert-mybets-view-v2" tracking="mybets" [model]="alertData" [disable]="false"></ms-alert>
                            <div class="button-label">{{ sitecoreMyBets.myBets.Alerts }}</div>
                        </div>
                    }

                    @if (showShareMyBetButton) {
                        <ms-share-my-bet [placedBetInfo]="placedBetInfo" [expandable]="false"></ms-share-my-bet>
                    }

                    @if (showEditBetHistoryButton) {
                        <div class="toolbar-button pin-button" (click)="editBetHistory($event)">
                            <vn-icon name="theme-edit-bet" size="16" />
                            <div class="button-label">{{ sitecoreMyBets.myBets.EditBetHistoryIconText }}</div>
                            @if (isToolbarVisible) {
                                <div class="my-bets-edit-bet-history-tooltip" msInfoyTooltip>
                                    <span class="my-bets-edit-bet-history-tooltip-text">{{ sitecoreMyBets.myBets.EditBetHistoryIconTooltip }}</span>
                                    <span class="close-btn-container">
                                        <button
                                            class="close-btn"
                                            ds-button-icon
                                            size="small"
                                            variant="flat-reduce"
                                            kind="tertiary"
                                            (click)="editBetHistoryTooltipClick($event)">
                                            <vn-icon name="theme-ex" size="12" />
                                        </button>
                                    </span>
                                </div>
                            }
                        </div>
                    }

                    @if (showCashoutUnavailableInfo) {
                        <div class="toolbar-button pin-button cashout-unavailable-icon" (click)="clickCashOutInfo($event)">
                            <vn-icon size="16" [name]="!cashoutInfoVisible ? 'theme-info' : 'theme-info-i'" />
                            <div class="button-label cashout-unavailable-label">{{ sitecoreMyBets.myBets.CashoutUnavailableInfoText }}</div>
                            @if (cashoutInfoVisible) {
                                <div class="cashout-unavailable-tooltip">
                                    <span class="cashout-unavailable-tooltip-text">{{ cashoutUnavailableInfoTooltipText }}</span>
                                    <div class="cashout-unavailable-close"><vn-icon name="theme-ex" size="12" /></div>
                                </div>
                            }
                        </div>
                    }

                    @if (hasValidExportIconType) {
                        <button
                            class="my-bet-print-btn"
                            ds-button-icon
                            size="medium"
                            variant="flat-reduce"
                            kind="tertiary"
                            (click)="clickPrintButton($event)">
                            <vn-icon name="theme-print" size="16" />
                        </button>
                    }
                </div>
                <div class="toolbar-toggle">
                    <div class="toolbar-button toggle" (click)="toggleToolbar($event)">
                        <vn-icon name="theme-down" size="12" />
                        @if (!hasButtons) {
                            <span class="button-label">{{ sitecoreMyBets.myBets.Details }}</span>
                        }
                    </div>
                </div>
            </div>
        }

        <div class="clear"></div>
        <div
            [ngClass]="showTaxDetails ? 'toolbar-tax-info-box clear' : 'toolbar-info-box clear'"
            [class.device-toolbar-info]="shouldShowDeviceDetails">
            @if (!showTaxDetails && hasTaxationInfo) {
                <div class="taxation-info">
                    <span>{{ taxationInfo }}</span>
                </div>
            }

            @if (showTaxDetails && hasTaxationInfo) {
                <div class="taxation-info">
                    @if (showTurnoverTax) {
                        <ms-my-bets-taxinfo
                            [grossAmount]="getGrossStake"
                            [tax]="getTurnoverTax"
                            [netAmount]="getStakeNet"
                            [grossTitle]="sitecoreMyBets.myBets.StakeGross"
                            [taxTitle]="sitecoreMyBets.myBetsTax.TurnoverTaxPercentage"
                            [netTitle]="sitecoreMyBets.myBets.StakeNet"></ms-my-bets-taxinfo>
                    }

                    @if (showWinningTax) {
                        <div class="taxation-info-line-border"></div>
                        <ms-my-bets-taxinfo
                            [grossAmount]="getGrossWinning"
                            [tax]="getWinningTax"
                            [netAmount]="getWinningNet"
                            [grossTitle]="sitecoreMyBets.myBets.Gross"
                            [taxTitle]="sitecoreMyBets.myBetsTax.TaxPercentage"
                            [netTitle]="sitecoreMyBets.myBets.MyBetsNetWinnings"></ms-my-bets-taxinfo>
                    }
                </div>
            }

            @if (hasExternalTicketId) {
                <div class="external-ticket">
                    <div>{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslipId }}</div>
                    <div>{{ sitecoreMyBets.myBets.AamsId }}: {{ betslip.licenseId }}</div>
                    <div>
                        {{ sitecoreMyBets.myBets.PsqfNumber }}:
                        <a class="external-ticket-link highlight" target="_blank" [href]="externalTicketLink">{{ betslip.externalTicketId }}</a>
                    </div>
                </div>
            }

            @if (hasAutoCashoutInfo) {
                <div class="auto-cashout-info">
                    <ms-my-bets-auto-cashout-badge></ms-my-bets-auto-cashout-badge>
                    <span>{{ sitecore.earlyPayoutV2.PaidOutAutoCashoutText }}: {{ autoCashoutValue }}</span>
                </div>
            }

            @if (oddsBoostInfoIncluded) {
                <div class="reward-token-info odds-boost" [innerHTML]="oddsBoostInfoContent"></div>
            }

            @if (accaBoostInfoIncluded) {
                <div class="reward-token-info acca-boost" [innerHTML]="accaBoostInfoContent"></div>
            }

            @if (riskFreeInfoIncluded) {
                <div class="reward-token-info" [innerHTML]="riskFreeInfoContent"></div>
            }

            @if (!myBetsListContext.isPrintView) {
                <div class="bet-info my-bets-toolbar-btn">
                    @if (shouldShowDeviceDetails) {
                        @if (deviceOSVersion$ | async; as deviceOSVersion) {
                            <p class="date-time">
                                <span class="date">{{ betPlacedDate | date: 'MM/dd/yy' }}</span>
                                <span class="time">{{ betPlacedDate | date: 'h:mm a' }}</span>
                            </p>
                            <button
                                class="bet-info-btn"
                                ds-button
                                kind="tertiary"
                                variant="flat-reduce"
                                size="small"
                                (click)="copyToClipboard($event)">
                                <span>{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslipId }}</span>
                                <span slot="start">
                                    <vn-icon name="theme-copy-clipboard" size="12" />
                                </span>
                            </button>
                            <span class="device-info">{{ sitecoreMyBets.myBets.DeviceDetails }}: {{ deviceOSVersion }}</span>
                        } @else {
                            <span>{{ sitecore.globalMessages.Loading }}</span>
                        }
                    } @else {
                        <span class="my-bets-toolbar-date">{{ betPlacedDate | msMyBetsEventDatePipe }}</span>
                        <button class="bet-info-btn" ds-button kind="tertiary" variant="flat-reduce" size="small" (click)="copyToClipboard($event)">
                            <span>{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslipId }}</span>
                            <span slot="start">
                                <vn-icon name="theme-copy-clipboard" size="12" />
                            </span>
                        </button>
                    }
                    <div class="clear"></div>
                </div>
            }

            <div class="clear"></div>
        </div>
    </div>
}
